import * as React from "react";

import { reject } from "../../../TypingUtils";
import { IDigestApiClient } from "../IDigestApiClient";

const DigestApiClientContext = React.createContext<IDigestApiClient | undefined>(undefined);

export const DigestApiClientProvider = DigestApiClientContext.Provider;

export function useDigestApiClient(): IDigestApiClient {
    return (
        React.useContext(DigestApiClientContext) ??
        reject("IDigestApiClient must be provided with DigestApiClientProvider")
    );
}
